var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00396633 9.98431C0.00331593 9.65111 0.119362 9.32819 0.331964 9.07162L7.46234 0.515173C7.7044 0.223945 8.05224 0.0408018 8.42933 0.00603444C8.80642 -0.0287329 9.18188 0.0877231 9.47311 0.329783C9.76434 0.571843 9.94748 0.919679 9.98225 1.29677C10.017 1.67386 9.90056 2.04932 9.6585 2.34055L3.26968 9.98431L9.43033 17.6281C9.54878 17.7739 9.63725 17.9418 9.69063 18.122C9.74401 18.3021 9.76125 18.4911 9.74138 18.6779C9.7215 18.8648 9.66489 19.0459 9.5748 19.2108C9.4847 19.3757 9.36291 19.5212 9.21641 19.6388C9.06978 19.7694 8.89776 19.8684 8.71113 19.9294C8.52449 19.9904 8.32726 20.0122 8.1318 19.9935C7.93634 19.9747 7.74685 19.9158 7.57521 19.8205C7.40358 19.7251 7.25349 19.5953 7.13434 19.4392L0.2464 10.8827C0.0674038 10.6188 -0.0179539 10.3025 0.00396633 9.98431Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.2fb61c45bcbd9159968712f76193b9ec.svg";
export { ForwardRef as ReactComponent };